import i18next from 'i18next';

import en from './assets/locales/en.json';
import tw from './assets/locales/zh-tw.json';
import ja from './assets/locales/ja-jpn.json';

import { initReactI18next } from 'react-i18next';
import { normalizeLanguage } from './utils/LanguageCode';

const resources = {
  ja: {
    translation: ja
  },
  en: {
    translation: en
  },
  'zh-TW': {
    translation: tw
  }
};

i18next.use(initReactI18next).init({
  resources,
  // ECOPD-5566：`navigator.language` 會是 `en-US` / `ja-JP` / `zh-Hant-TW` 這種帶
  // 地區碼（甚至帶書寫系統）的值，直接當 `lng` 會讓 `i18n.language` 一路髒下去，
  // `zh-Hant-TW` 更是連 i18next 都解不出 `zh-TW`、整包掉到 `fallbackLng`。
  // 收斂成 resources 真的有的那三個 key，理由與細節見 `utils/LanguageCode`。
  // （`|| 'zh-TW'` 保留原本「瀏覽器什麼都沒給就用中文」的行為。）
  lng: normalizeLanguage(navigator.language || 'zh-TW'),
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false
  }
});

export default i18next;
